import React from 'react';
import { useApiLoadingPool, usePreventInfiniteLoading, useRouter, useScrollToTop, } from '@/util/hook/custom';
import useCallback from '@/util/hook/useCallback';
import useDispatch from '@/util/hook/useDispatch';
import useEffect from '@/util/hook/useEffect';
import useSelector from '@/util/hook/useSelector';
import useState from '@/util/hook/useState';
import { selectLiffId } from '@/util/redux/auth';
import { handleSkipCurrentPage } from '../../util/helper/handleSkipCurrentPage';
import { updateCareClientProfile } from '../../util/helper/profileUpdate';
import { useGetCareClientVisitorProfile } from '../../util/hook/useGetCareClientVisitorProfile';
import { useGetRemoteConfig } from '../../util/hook/useGetRemoteConfig';
import { usePageHeight } from '../../util/hook/usePageHeight';
import { useTrackBrowserHistory } from '../../util/hook/useTrackBrowserHistory';
import { useValidateCareClientVisitorProfileAndRedirect } from '../../util/hook/useValidateCareClientVisitorProfileAndRedirect';
import { selectCareClientVisitorProfile, } from '../../redux/module/careClientVisitorProfile';
import { selectIsCareClientVisitorProfileInitialized } from '../../redux/module/tracker';
import View from './View';
import { APP } from '../../config/app';
const useSkipCurrentPage = ({ isCareClientVisitorProfileInitialized, careClientVisitorProfile, fromPage, currentPage, navigate, }) => {
    useEffect(() => {
        if (!isCareClientVisitorProfileInitialized)
            return;
        if (fromPage === null)
            return;
        const shouldSkip = Boolean(careClientVisitorProfile.contract);
        if (!shouldSkip)
            return;
        handleSkipCurrentPage({
            fromPage,
            currentPage,
            navigate,
            nextPage: APP.ROUTES.HOSPITAL,
            prevPage: APP.ROUTES.CONTACT_INFO,
        });
    }, [isCareClientVisitorProfileInitialized, fromPage]);
};
export default function Controller() {
    const { isLoading, setLoading, setApiProcessingPool, setApiDonePool } = useApiLoadingPool(true);
    const [isChecked, setIsChecked] = useState(false);
    const _id = useSelector(selectLiffId);
    const isCareClientVisitorProfileInitialized = useSelector(selectIsCareClientVisitorProfileInitialized);
    const careClientVisitorProfile = useSelector(selectCareClientVisitorProfile);
    const dispatch = useDispatch();
    const { navigate, navigateError, useLocation } = useRouter();
    const location = useLocation();
    const currentPage = location.pathname;
    const { fromPage } = useTrackBrowserHistory();
    useSkipCurrentPage({
        isCareClientVisitorProfileInitialized,
        careClientVisitorProfile,
        fromPage,
        currentPage,
        navigate,
    });
    useGetRemoteConfig({ setApiProcessingPool, setApiDonePool });
    useGetCareClientVisitorProfile({
        setApiProcessingPool,
        setApiDonePool,
    });
    useValidateCareClientVisitorProfileAndRedirect({ redirectRoute: null });
    useScrollToTop();
    usePreventInfiniteLoading({ setApiProcessingPool, setApiDonePool });
    const { pageHeight } = usePageHeight();
    // event handlers
    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
    };
    const handleBackButtonClick = useCallback(() => {
        navigate(APP.ROUTES.CONTACT_INFO);
    }, []);
    const handleForwardButtonClick = useCallback(async () => {
        setLoading(true);
        const { isSuccess } = await updateCareClientProfile({
            _id,
            updatedData: {
                contract: true,
            },
            dispatch,
            navigateError,
        });
        if (isSuccess) {
            navigate(APP.ROUTES.HOSPITAL);
        }
        setLoading(false);
    }, []);
    return (<View 
    // data
    isLoading={isLoading} isChecked={isChecked} pageHeight={pageHeight} 
    // func
    handleCheckboxChange={handleCheckboxChange} handleBackButtonClick={handleBackButtonClick} handleForwardButtonClick={handleForwardButtonClick}/>);
}
